/**
 * @generated SignedSource<<4e650d693befb924a956a563b2acf463>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type agileArticleOneQuery$variables = {
  limit?: number | null | undefined;
  locale: string;
  urlSlug: string;
};
export type agileArticleOneQuery$data = {
  readonly articleDetailsCollection: {
    readonly items: ReadonlyArray<{
      readonly articleIntroductionCollection: {
        readonly items: ReadonlyArray<{
          readonly articleIntroductionAsset: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly name: string | null | undefined;
            readonly size: number | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly articleIntroductionDetails: {
            readonly json: any;
          } | null | undefined;
          readonly articleIntroductionName: string | null | undefined;
          readonly componentizedIntroductionCollection: {
            readonly items: ReadonlyArray<{
              readonly __typename: "AssetComponent";
              readonly asset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly assetRelatedText: {
                readonly json: any;
              } | null | undefined;
              readonly caption: string | null | undefined;
            } | {
              readonly __typename: "CallOutComponent";
              readonly callOutText: {
                readonly json: any;
              } | null | undefined;
              readonly icon: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly title: string | null | undefined;
            } | {
              readonly __typename: "CallToAction";
              readonly asset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly ctaText: string | null | undefined;
              readonly dataBlueprintModule: string | null | undefined;
              readonly productCollection: {
                readonly items: ReadonlyArray<{
                  readonly productLogo: {
                    readonly contentType: string | null | undefined;
                    readonly description: string | null | undefined;
                    readonly fileName: string | null | undefined;
                    readonly height: number | null | undefined;
                    readonly name: string | null | undefined;
                    readonly size: number | null | undefined;
                    readonly url: string | null | undefined;
                    readonly width: number | null | undefined;
                  } | null | undefined;
                  readonly productNameReference: {
                    readonly productName: string | null | undefined;
                  } | null | undefined;
                } | null | undefined>;
              } | null | undefined;
              readonly title: string | null | undefined;
              readonly url: string | null | undefined;
              readonly valueProposition: string | null | undefined;
            } | {
              readonly __typename: "ProTipComponent";
              readonly name: string | null | undefined;
              readonly proTipText: string | null | undefined;
            } | {
              readonly __typename: "QuestionComponent";
              readonly answer: {
                readonly json: any;
              } | null | undefined;
              readonly answerAsset: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly questionTitle: string | null | undefined;
            } | {
              readonly __typename: "TextComponent";
              readonly name: string | null | undefined;
              readonly text: {
                readonly json: any;
              } | null | undefined;
            } | {
              readonly __typename: "TwitterComponent";
              readonly tweetText: string | null | undefined;
              readonly twitterComponentName: string | null | undefined;
              readonly twitterUrl: string | null | undefined;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined>;
          } | null | undefined;
          readonly embedLink: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly articleRef: {
        readonly articleBanner: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly name: string | null | undefined;
          readonly size: number | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly articleName: string | null | undefined;
        readonly description: string | null | undefined;
        readonly title: string | null | undefined;
        readonly urlSlug: string | null | undefined;
      } | null | undefined;
      readonly articleSummary: {
        readonly json: any;
      } | null | undefined;
      readonly author: {
        readonly authorPicture: {
          readonly contentType: string | null | undefined;
          readonly description: string | null | undefined;
          readonly fileName: string | null | undefined;
          readonly height: number | null | undefined;
          readonly name: string | null | undefined;
          readonly size: number | null | undefined;
          readonly url: string | null | undefined;
          readonly width: number | null | undefined;
        } | null | undefined;
        readonly jobTitle: string | null | undefined;
        readonly name: string | null | undefined;
        readonly shortBiography: string | null | undefined;
      } | null | undefined;
      readonly contentHubSubscribeCollection: {
        readonly items: ReadonlyArray<{
          readonly ctaButtonText: string | null | undefined;
          readonly subscribeComponentName: string | null | undefined;
          readonly successMessage: string | null | undefined;
          readonly valueProposition: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly productDiscussedCtaCollection: {
        readonly items: ReadonlyArray<{
          readonly asset: {
            readonly contentType: string | null | undefined;
            readonly description: string | null | undefined;
            readonly fileName: string | null | undefined;
            readonly height: number | null | undefined;
            readonly name: string | null | undefined;
            readonly size: number | null | undefined;
            readonly url: string | null | undefined;
            readonly width: number | null | undefined;
          } | null | undefined;
          readonly dataBlueprintModule: string | null | undefined;
          readonly productCollection: {
            readonly items: ReadonlyArray<{
              readonly productLogo: {
                readonly contentType: string | null | undefined;
                readonly description: string | null | undefined;
                readonly fileName: string | null | undefined;
                readonly height: number | null | undefined;
                readonly name: string | null | undefined;
                readonly size: number | null | undefined;
                readonly url: string | null | undefined;
                readonly width: number | null | undefined;
              } | null | undefined;
              readonly productNameReference: {
                readonly productName: string | null | undefined;
              } | null | undefined;
            } | null | undefined>;
          } | null | undefined;
          readonly text: string | null | undefined;
          readonly title: string | null | undefined;
          readonly url: string | null | undefined;
          readonly valueProposition: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly relatedHubCollection: {
        readonly items: ReadonlyArray<{
          readonly description: {
            readonly json: any;
          } | null | undefined;
          readonly shortDescriptionOneLiner: string | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly subtitle: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type agileArticleOneQuery = {
  response: agileArticleOneQuery$data;
  variables: agileArticleOneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": 1,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "locale"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlSlug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  },
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "urlSlug",
            "variableName": "urlSlug"
          }
        ],
        "kind": "ObjectValue",
        "name": "articleRef"
      }
    ],
    "kind": "ObjectValue",
    "name": "where"
  }
],
v4 = {
  "alias": "subtitle",
  "args": null,
  "kind": "ScalarField",
  "name": "articleSubtitle",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "json",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleDetailsArticleSummary",
  "kind": "LinkedField",
  "name": "articleSummary",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueProposition",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 3
    }
  ],
  "concreteType": "ArticleDetailsContentHubSubscribeCollection",
  "kind": "LinkedField",
  "name": "contentHubSubscribeCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SubscribeComponent",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "subscribeComponentName",
          "args": null,
          "kind": "ScalarField",
          "name": "subscribeComponentNameExternal",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaButtonText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "successMessage",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "contentHubSubscribeCollection(limit:3)"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = [
  (v9/*: any*/),
  {
    "alias": "name",
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "width",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "height",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fileName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "contentType",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "MicrositeArticle",
  "kind": "LinkedField",
  "name": "articleRef",
  "plural": false,
  "selections": [
    {
      "alias": "articleName",
      "args": null,
      "kind": "ScalarField",
      "name": "articleNameExternal",
      "storageKey": null
    },
    {
      "alias": "title",
      "args": null,
      "kind": "ScalarField",
      "name": "articleTitle",
      "storageKey": null
    },
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "articleBanner",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": "name",
      "args": null,
      "kind": "ScalarField",
      "name": "authorNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortBiography",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "authorPicture",
      "plural": false,
      "selections": (v10/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v14 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "ArticleDetailsRelatedHubCollection",
  "kind": "LinkedField",
  "name": "relatedHubCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaxonomyContentHub",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": "title",
          "args": null,
          "kind": "ScalarField",
          "name": "contentHubTitleExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortDescriptionOneLiner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyContentHubDescription",
          "kind": "LinkedField",
          "name": "description",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "relatedHubCollection(limit:1)"
},
v15 = {
  "alias": "articleIntroductionName",
  "args": null,
  "kind": "ScalarField",
  "name": "articleIntroductionTitleExternal",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleIntroductionArticleIntroductionDetails",
  "kind": "LinkedField",
  "name": "articleIntroductionDetails",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "embedLink",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "articleIntroductionAsset",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v19 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 10
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v21 = {
  "alias": "caption",
  "args": null,
  "kind": "ScalarField",
  "name": "assetCaption",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetComponentAssetRelatedText",
  "kind": "LinkedField",
  "name": "assetRelatedText",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "proTipNameExternal",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proTipText",
  "storageKey": null
},
v26 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "textComponentNameExternal",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "TextComponentText",
  "kind": "LinkedField",
  "name": "text",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaTitleExternal",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaText",
  "storageKey": null
},
v30 = {
  "alias": "url",
  "args": null,
  "kind": "ScalarField",
  "name": "ctaUrl",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "CallToActionProductCollection",
  "kind": "LinkedField",
  "name": "productCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductListing",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductName",
          "kind": "LinkedField",
          "name": "productNameReference",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "productLogo",
          "args": null,
          "concreteType": "Asset",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productCollection(limit:1)"
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataBlueprintModule",
  "storageKey": null
},
v33 = {
  "alias": "asset",
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "ctaAsset",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": "questionTitle",
  "args": null,
  "kind": "ScalarField",
  "name": "questionTitleExternal",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "QuestionComponentAnswer",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "answerAsset",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": "twitterComponentName",
  "args": null,
  "kind": "ScalarField",
  "name": "twitterComponentExternalName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tweetText",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterUrl",
  "storageKey": null
},
v40 = {
  "alias": "title",
  "args": null,
  "kind": "ScalarField",
  "name": "callOutComponentTitleExternal",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "CallOutComponentCallOutText",
  "kind": "LinkedField",
  "name": "callOutText",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v42 = {
  "alias": "icon",
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "callOutComponentIcon",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "ArticleDetailsProductDiscussedCtaCollection",
  "kind": "LinkedField",
  "name": "productDiscussedCtaCollection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CallToAction",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v28/*: any*/),
        (v7/*: any*/),
        {
          "alias": "text",
          "args": null,
          "kind": "ScalarField",
          "name": "ctaText",
          "storageKey": null
        },
        (v30/*: any*/),
        (v33/*: any*/),
        (v31/*: any*/),
        (v32/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "productDiscussedCtaCollection(limit:1)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "agileArticleOneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ArticleDetailsCollection",
        "kind": "LinkedField",
        "name": "articleDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "ArticleDetailsArticleIntroductionCollection",
                "kind": "LinkedField",
                "name": "articleIntroductionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleIntroduction",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": (v19/*: any*/),
                        "concreteType": "ArticleIntroductionComponentizedIntroductionCollection",
                        "kind": "LinkedField",
                        "name": "componentizedIntroductionCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "type": "AssetComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/)
                                ],
                                "type": "ProTipComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "type": "TextComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v28/*: any*/),
                                  (v7/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "type": "CallToAction",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "type": "QuestionComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/)
                                ],
                                "type": "TwitterComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v20/*: any*/),
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/)
                                ],
                                "type": "CallOutComponent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "componentizedIntroductionCollection(limit:10)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "articleIntroductionCollection(limit:1)"
              },
              (v43/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "agileArticleOneQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ArticleDetailsCollection",
        "kind": "LinkedField",
        "name": "articleDetailsCollection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleDetails",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "ArticleDetailsArticleIntroductionCollection",
                "kind": "LinkedField",
                "name": "articleIntroductionCollection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArticleIntroduction",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": (v19/*: any*/),
                        "concreteType": "ArticleIntroductionComponentizedIntroductionCollection",
                        "kind": "LinkedField",
                        "name": "componentizedIntroductionCollection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v20/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/)
                                ],
                                "type": "AssetComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/)
                                ],
                                "type": "ProTipComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "type": "TextComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v28/*: any*/),
                                  (v7/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/)
                                ],
                                "type": "CallToAction",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v34/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/)
                                ],
                                "type": "QuestionComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  (v39/*: any*/)
                                ],
                                "type": "TwitterComponent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v40/*: any*/),
                                  (v41/*: any*/),
                                  (v42/*: any*/)
                                ],
                                "type": "CallOutComponent",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "componentizedIntroductionCollection(limit:10)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "articleIntroductionCollection(limit:1)"
              },
              (v43/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7416521799a990b9a442c43a94a8fe36",
    "id": null,
    "metadata": {},
    "name": "agileArticleOneQuery",
    "operationKind": "query",
    "text": "query agileArticleOneQuery(\n  $limit: Int = 1\n  $urlSlug: String!\n  $locale: String!\n) {\n  articleDetailsCollection(limit: $limit, where: {articleRef: {urlSlug: $urlSlug}}, locale: $locale) {\n    items {\n      subtitle: articleSubtitle\n      articleSummary {\n        json\n      }\n      contentHubSubscribeCollection(limit: 3) {\n        items {\n          subscribeComponentName: subscribeComponentNameExternal\n          valueProposition\n          ctaButtonText\n          successMessage\n        }\n      }\n      articleRef {\n        articleName: articleNameExternal\n        title: articleTitle\n        description\n        urlSlug\n        articleBanner {\n          description\n          name: title\n          url\n          width\n          height\n          size\n          fileName\n          contentType\n        }\n      }\n      author {\n        name: authorNameExternal\n        jobTitle\n        shortBiography\n        authorPicture {\n          description\n          name: title\n          url\n          width\n          height\n          size\n          fileName\n          contentType\n        }\n      }\n      relatedHubCollection(limit: 1) {\n        items {\n          title: contentHubTitleExternal\n          shortDescriptionOneLiner\n          description {\n            json\n          }\n        }\n      }\n      articleIntroductionCollection(limit: 1) {\n        items {\n          articleIntroductionName: articleIntroductionTitleExternal\n          articleIntroductionDetails {\n            json\n          }\n          embedLink\n          articleIntroductionAsset {\n            description\n            name: title\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          componentizedIntroductionCollection(limit: 10) {\n            items {\n              __typename\n              ... on AssetComponent {\n                __typename\n                caption: assetCaption\n                assetRelatedText {\n                  json\n                }\n                asset {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n              ... on ProTipComponent {\n                __typename\n                name: proTipNameExternal\n                proTipText\n              }\n              ... on TextComponent {\n                __typename\n                name: textComponentNameExternal\n                text {\n                  json\n                }\n              }\n              ... on CallToAction {\n                __typename\n                title: ctaTitleExternal\n                valueProposition\n                ctaText\n                url: ctaUrl\n                productCollection(limit: 1) {\n                  items {\n                    productNameReference {\n                      productName\n                    }\n                    productLogo: icon {\n                      description\n                      name: title\n                      url\n                      width\n                      height\n                      size\n                      fileName\n                      contentType\n                    }\n                  }\n                }\n                dataBlueprintModule\n                asset: ctaAsset {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n              ... on QuestionComponent {\n                __typename\n                questionTitle: questionTitleExternal\n                answer {\n                  json\n                }\n                answerAsset {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n              ... on TwitterComponent {\n                __typename\n                twitterComponentName: twitterComponentExternalName\n                tweetText\n                twitterUrl\n              }\n              ... on CallOutComponent {\n                __typename\n                title: callOutComponentTitleExternal\n                callOutText {\n                  json\n                }\n                icon: callOutComponentIcon {\n                  description\n                  name: title\n                  url\n                  width\n                  height\n                  size\n                  fileName\n                  contentType\n                }\n              }\n            }\n          }\n        }\n      }\n      productDiscussedCtaCollection(limit: 1) {\n        items {\n          title: ctaTitleExternal\n          valueProposition\n          text: ctaText\n          url: ctaUrl\n          asset: ctaAsset {\n            description\n            name: title\n            url\n            width\n            height\n            size\n            fileName\n            contentType\n          }\n          productCollection(limit: 1) {\n            items {\n              productNameReference {\n                productName\n              }\n              productLogo: icon {\n                description\n                name: title\n                url\n                width\n                height\n                size\n                fileName\n                contentType\n              }\n            }\n          }\n          dataBlueprintModule\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e11f498c04250031fbce3009ac5d992b";

export default node;
